export namespace EinlasskontrolleConstants {
    export const BOUNDED_CONTEXT_NAME = 'Einlasskontrolle';
    export const EINLASSKONTROLLE_LIZENZ_MODUL = 'einlasskontrolle';
    export const PROTOKOLLIERUNG_LIZENZ_OPTION = 'protokollierung';
    
}

